<template>
<div class="pt-1">
  <div class="row d-flex align-items-center justify-content-center justify-content-sm-start">
    <div class="col-sm-6 mx-0 p-0">
      <div class="rankingPic">
        <img src="../assets/images/pic_elf_04.png">
      </div>
    </div>

    <div class="col-sm-6 col-lg-4 col-md-6">
      <div class="">
        <div class="row d-flex flex-column flex-sm-row">
          <div class="col-sm-12 col-12 mb-3 pt-0 pt-sm-3 pt-md-3  pt-lg-3 d-flex justify-content-center justify-content-sm-start" >
            <div class="border d-flex justify-content-center ">
              <div class="border_padding ">
                <div class="rankingtext pt-2 pb-3 pr-0 pl-0 pt-lg-0 pb-lg-2 pr-lg-2 pl-lg-2 pt-md-0 pb-md-3 pl-md-2 pr-md-2 pt-sm-0 pb-sm-2 pt-2">
                  <p>謝謝各位小幫手的幫忙，本次任務排名如下：</p>
                </div>
              </div>
              <div class="scrollbar" id="style-3">
                <div class="force-overflow text-left">
                <!-- card -->
                  <div class="card" style="width: 100%;" v-for="(user, index) in users" :key="user.UserId">
                    <div class="card-body d-flex align-items-center">
                      <div class="trophy">
                        <img src="../assets/images/icon_cup_1.png" v-if="index === 0">
                        <img src="../assets/images/icon_cup_2.png" v-if="index === 1">
                        <img src="../assets/images/icon_cup_3.png" v-if="index === 2">
                      </div>
                      <h5 class="card-title ml-3">{{ user.NickName }}</h5>
                    </div>
                  </div>
                  <!-- card -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center pb-3 pt-4 pb-xl-5">
    <div class="finishMission">
      <a class="btn btn-pink">結束活動</a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'MissionRanking',

  props: {
    users: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .finishMission {
    margin: 0 auto;
  }
  .btn {
    display: block;
    padding: 10px 30px;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    font-size: 1em;
  }

  .rankingPic {
  max-width: 600px;
    img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    }
  }
  // scroll
  #style-3::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  #style-3::-webkit-scrollbar {
    width: 4px;
    background-color: #F5F5F5;
  }

  #style-3::-webkit-scrollbar-thumb{
    background-color: #000000;
  }

  .border {
    width: 100%;
    height: 72vh;
    position: relative;
    background-color: white;
    border-radius: 6px;
    border: 2px solid #F5F5F5;
    .border_padding {
      padding: 8px 12px;
      .rankingtext {
        border-bottom: 0.5px solid gray;
        p {
          line-height:1.5em;
          font-size:1.1em;
          font-weight: 900;
          color:#1351a4;
          text-align: left;
          margin: 0;
        }
      }
    }
  }
  .scrollbar {
    max-height: 77%;
    width: 98%;
    background: white;
    overflow-y: scroll;
    position: absolute;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
    padding-right: 18px;
    overflow-x:hidden;
  }

  @media screen and (max-width: 769px) {
    .scrollbar {
      top: 20%;
    }
  }
  @media screen and (max-width: 577px) {
    .scrollbar {
      top: 21%;
    }
  }
  .force-overflow {
    min-height: 300px;
    .content {
      img{
        max-width: 460px;
      }
    }
    .fileName {
      word-wrap: break-word;
    }
  }
  .card {
    border: none !important;
    .card-body {
      padding: 15px 20px !important;
    }
    h5 {
      font-size: 1.2em;
      color: #f46a7c;
      font-weight: 800;
      font-family: 'Times New Roman', Times, serif;
    }
    .trophy {
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
</style>
